/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigTimeSection_ConfigFragment = { __typename: 'ConfigurationModel', id: string, firmware?: { __typename: 'ConfigFirmware', android: { __typename: 'ConfigAndroid', version: any } } | null, timeZone?: { __typename: 'ConfigTimeZoneState', reported: string, supportedValues: Array<string> } | null };

export type ConfigUpdateTimeZoneMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateTimeZoneInput;
}>;


export type ConfigUpdateTimeZoneMutation = { __typename: 'Mutation', configurationUpdateTimeZone: { __typename: 'ConfigurationModel', id: string, timeZone?: { __typename: 'ConfigTimeZoneState', reported: string } | null } };

export const ConfigTimeSection_ConfigFragmentDoc = gql`
    fragment ConfigTimeSection_config on ConfigurationModel {
  id
  firmware {
    android {
      version
    }
  }
  timeZone {
    reported
    supportedValues
  }
}
    `;
export const ConfigUpdateTimeZoneDocument = gql`
    mutation ConfigUpdateTimeZone($input: ConfigurationUpdateTimeZoneInput!) {
  configurationUpdateTimeZone(input: $input) {
    id
    timeZone {
      reported
    }
  }
}
    `;
export type ConfigUpdateTimeZoneMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateTimeZoneMutation, ConfigUpdateTimeZoneMutationVariables>;

/**
 * __useConfigUpdateTimeZoneMutation__
 *
 * To run a mutation, you first call `useConfigUpdateTimeZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateTimeZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateTimeZoneMutation, { data, loading, error }] = useConfigUpdateTimeZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateTimeZoneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateTimeZoneMutation, ConfigUpdateTimeZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateTimeZoneMutation, ConfigUpdateTimeZoneMutationVariables>(ConfigUpdateTimeZoneDocument, options);
      }
export type ConfigUpdateTimeZoneMutationHookResult = ReturnType<typeof useConfigUpdateTimeZoneMutation>;
export type ConfigUpdateTimeZoneMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateTimeZoneMutation>;
export type ConfigUpdateTimeZoneMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateTimeZoneMutation, ConfigUpdateTimeZoneMutationVariables>;